<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Note dell'ordine</span>
</div>

<form class="step-fields step-fields--half" [formGroup]="form" (ngSubmit)="continue()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Titolo nota</mat-label>
    <input matInput formControlName="titolo" maxlength="100">
    @if (!valid) {
      <mat-hint class="note-title-required">Campo obbligatorio</mat-hint>
    }
  </mat-form-field>

  <mat-form-field class="step-field--wide text-area-custom" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Testo nota</mat-label>
    <textarea matInput rows="4" formControlName="testo"></textarea>
  </mat-form-field>

  @if (contrassegno()) {
    <div class="note-hint">
      <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
      <span class="body-large">Inserisci il numero di telefono associato al contrassegno</span>
    </div>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Data nota</mat-label>
    <input matInput disabled [value]="today | date: 'dd/MM/yyyy'">
    <i matSuffix class="fa-regular fa-calendar" aria-hidden="true"></i>
  </mat-form-field>

  <div class="note-order-box">
    <span class="note-order-title body-large-emphasized">Aggiungi ad ogni richiesta autorizzazione ordine</span>
    <span class="body-large">La nota sarà proposta automaticamente quando si crea una richiesta autorizzazione ordine per questo cliente.</span>
    <mat-slide-toggle formControlName="addOrdine" aria-label="Aggiungi ad ogni richiesta autorizzazione ordine" />
  </div>
</form>

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!valid" (click)="continue()">Prosegui</button>
</div>
